"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
const tslib_1 = require("tslib");
const qs_stringify_1 = tslib_1.__importDefault(require("qs-stringify"));
const removeEmptyKeys_1 = require("./removeEmptyKeys");
class Resource {
    constructor(client) {
        this.client = client;
        this.endpoint = '';
    }
    static createByResourceName(client, resourceName) {
        const resource = new Resource(client);
        resource.endpoint = `${resourceName}s`;
        return resource;
    }
    create(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.post(`${this.endpoint}`, payload);
            return response;
        });
    }
    update(id, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.patch(`${this.endpoint}/${id}`, payload);
            return response;
        });
    }
    find(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${this.endpoint}/${id}`);
            return response;
        });
    }
    delete(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.delete(`${this.endpoint}/${id}`);
            return response;
        });
    }
    list(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            params = (0, removeEmptyKeys_1.removeEmptyKeys)(params);
            const paramsString = (0, qs_stringify_1.default)(params);
            const url = params && Object.keys(params).length ? `${this.endpoint}?${paramsString}` : this.endpoint;
            const response = yield this.client.get(url);
            return response;
        });
    }
}
exports.Resource = Resource;
//# sourceMappingURL=Resource.js.map